import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import PocAdd from 'containers/request/Initial/Steps/Vendor/BillingPocAdd';
import PocSelector from 'containers/request/Initial/Steps/Vendor/BillingPocSelector';
import AddressAdd from 'containers/request/Initial/Steps/Vendor/BillingAddressAdd';
import AddressSelector from 'containers/request/Initial/Steps/Vendor/BillingAddressSelector';
import BillingSubmit from 'containers/request/Initial/Steps/Vendor/BillingSubmit';
import ReturnLink from 'containers/request/Initial/Steps/Vendor/BillingReturnLink';
import PurchaseOrder from 'containers/request/Initial/Steps/Vendor/BillingPurchaseOrder';
import { Bubble } from 'ctia-ui';
import { startPreloader, finishPreloader } from 'actions/preloader';
import {
  fetchPocs,
  cleanBillingPocInfo,
  cleanBillingAddressInfo
} from 'actions/request';
import { fetchCountries } from 'actions/countries';
import { fetchBillingAddresses } from 'actions/billing';

class Billing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isNewRequest: true,
      showPocSelector: true,
      showAddressSelector: true
    };

    this.pocReturnLinkTitle = 'I want to select PoC from a list';
    this.addressReturnLinkTitle =
      'I want to select Billing Address from a list';
  }

  fetchAddressList = () => {
    const { user, fetchBillingAddresses } = this.props;
    return fetchBillingAddresses(user.requestOwnerCompanyId);
  };

  fetchBillingData = () => {
    const {
      startPreloader,
      finishPreloader,
      fetchPocs,
      fetchCountries,
      user
    } = this.props;

    startPreloader();

    return fetchPocs(user.requestOwnerCompanyId)
      .then(this.fetchAddressList)
      .then(fetchCountries)
      .then(finishPreloader);
  };

  componentDidMount() {
    this.fetchBillingData();

    // init component state
    const isNewRequest = _.isUndefined(this.props.request.id);
    this.setState({ isNewRequest });
  }

  componentWillReceiveProps(nextProps) {
    const hasNoPocs = _.isEmpty(this.props.request.pocs);
    const hasNoAddresses = _.isEmpty(this.props.request.billingAddresses);

    // update state only one time
    if (hasNoPocs && nextProps.request.pocs) {
      const pocListExists = !_.isEmpty(nextProps.request.pocs);
      this.setState({ showPocSelector: pocListExists });
    }

    if (hasNoAddresses && _.isUndefined(nextProps.request.billingAddresses)) {
      const addressListExists = !_.isEmpty(nextProps.request.billingAddresses);
      this.setState({ showAddressSelector: addressListExists });
    }

    if (hasNoAddresses && nextProps.request.billingAddresses === false) {
      this.setState({ showAddressSelector: false });
    }

    if (hasNoAddresses && !_.isEmpty(nextProps.request.billingAddresses)) {
      this.setState({ showAddressSelector: true });
    }

    const { billingPocId, billingAddressId } = this.props.request;

    // fix for return to prev step issue (billing poc)
    if (
      _.isEmpty(String(billingPocId)) &&
      !_.isEmpty(String(nextProps.request.billingPocId)) &&
      this.state.showPocSelector === false
    ) {
      this.fetchBillingData().then(this.togglePocSelector(true));
    }

    // fix for return to prev step issue (billing address)
    if (
      _.isEmpty(String(billingAddressId)) &&
      !_.isEmpty(String(nextProps.request.billingAddressId)) &&
      this.state.showAddressSelector === false
    ) {
      this.fetchBillingData().then(this.toggleAddressSelector(true));
    }
  }

  togglePocSelector = value => {
    if (value === false) {
      this.props.cleanBillingPocInfo();
    }
    this.setState({ showPocSelector: value });
  };

  toggleAddressSelector = value => {
    this.setState({ showAddressSelector: value });
  };

  validate() {
    return this.props.request.pocId > 0;
  }

  pocLinkHandler = () => {
    // clean POC data from request
    this.props.cleanBillingPocInfo();

    // toggle selector view and show POC form instead
    this.togglePocSelector(true);
  };

  addressLinkHandler = () => {
    // remove Billing Address from request
    this.props.cleanBillingAddressInfo();

    // toggle selector view and show address form instead
    this.toggleAddressSelector(true);
  };

  render() {
    const { show, request } = this.props;

    if (!show) return null;

    const { showPocSelector, showAddressSelector, isNewRequest } = this.state;
    const showPocReturnLink =
      !showPocSelector && request.pocs && request.pocs.length > 0;
    const showAddressReturnLink =
      !showAddressSelector &&
      request.billingAddresses &&
      request.billingAddresses.length > 0;

    return (
      <div>
        <Bubble show={true}>
          Please select the <strong>Billing Point of Contact (PoC)</strong> and{' '}
          <strong>Billing Address</strong> for this request.
        </Bubble>
        <Form horizontal>
          <ReturnLink
            show={showPocReturnLink}
            title={this.pocReturnLinkTitle}
            linkHandler={this.pocLinkHandler}
          />
          <PocAdd
            show={!showPocSelector}
            isNew={isNewRequest}
            toggleSelector={this.togglePocSelector}
          />
          <PocSelector
            show={showPocSelector}
            isNew={isNewRequest}
            toggleSelector={this.togglePocSelector}
          />
          <hr />
          <ReturnLink
            show={showAddressReturnLink}
            title={this.addressReturnLinkTitle}
            linkHandler={this.addressLinkHandler}
          />
          <AddressAdd
            show={!showAddressSelector}
            isNew={isNewRequest}
            toggleSelector={this.toggleAddressSelector}
          />
          <AddressSelector
            show={showAddressSelector}
            isNew={isNewRequest}
            toggleSelector={this.toggleAddressSelector}
          />
          <PurchaseOrder />
          <hr />
          <BillingSubmit />
        </Form>
      </div>
    );
  }
}

Billing.propTypes = {
  show: PropTypes.bool
};

Billing.defaultProps = {
  show: true
};

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    startPreloader,
    finishPreloader,
    fetchPocs,
    fetchBillingAddresses,
    cleanBillingPocInfo,
    cleanBillingAddressInfo,
    fetchCountries
  }
)(Billing);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/Billing.js